/** Hosts of the media service (signed links: no auth headers needed). */
const mediaServiceHosts = ["media.mentoor.io", "cdn.mentoor.io"];

/**
 * Whether hls.js should attach our `Authorization` + `Domain` headers to a
 * playlist/segment request. Only the backend's own `/resources/stream/*`
 * needs them. Signed storage URLs (Cloudflare R2, the media service) must
 * get none: their CORS policy refuses `Authorization`, and the student's
 * token must not leave the API.
 */
export function shouldSendHlsHeaders(url: string): boolean {
  if (url.includes("cloudflare")) return false;

  try {
    const host = new URL(url, "https://localhost").hostname;

    return !mediaServiceHosts.includes(host);
  } catch {
    return true;
  }
}
